import type { HTMLAttributes } from 'react';
import { cx } from '../lib/cx';

export interface SpinnerProps extends HTMLAttributes<HTMLSpanElement> {
  /** Diameter in px (drives the em-based border). Default 18. */
  size?: number;
  label?: string;
}

/** Indeterminate loading spinner. Inherits currentColor. */
export function Spinner({ size = 18, label = 'Loading', className, style, ...rest }: SpinnerProps) {
  return (
    <span
      className={cx('tc-spinner', className)}
      role="status"
      aria-label={label}
      style={{ fontSize: size, ...style }}
      {...rest}
    />
  );
}
